export type ReviewEmailTemplate = {
  id: number;
  brand: string;
  email_type: string;
  brand_name: string;
  support_email: string;
  email_title: string | null;
  email_subject: string | null;
  greeting_text: string | null;
  product_mention_text: string | null;
  message_body_text: string | null;
  support_note_text: string | null;
  section_header_text: string | null;
  rating_label: string | null;
  rating_label_5: string | null;
  rating_label_4: string | null;
  rating_label_3: string | null;
  rating_label_2: string | null;
  rating_label_1: string | null;
  review_title_label: string | null;
  review_body_label: string | null;
  photo_tip_text: string | null;
  submit_button_text: string | null;
  footer_trouble_text: string | null;
  footer_link_text: string | null;
  brand_color: string | null;
  background_color: string | null;
  logo_url: string | null;
  banner_url: string | null;
  font_family: string | null;
  button_border_radius: string | null;
  computed_email_title: string;
  computed_email_subject: string;
  computed_greeting_text: string;
  computed_product_mention_text: string;
  computed_message_body_text: string;
  computed_support_note_text: string;
  computed_section_header_text: string;
  computed_rating_label: string;
  computed_rating_label_5: string;
  computed_rating_label_4: string;
  computed_rating_label_3: string;
  computed_rating_label_2: string;
  computed_rating_label_1: string;
  computed_review_title_label: string;
  computed_review_body_label: string;
  computed_photo_tip_text: string;
  computed_submit_button_text: string;
  computed_footer_trouble_text: string;
  computed_footer_link_text: string;
  computed_brand_color: string;
  computed_background_color: string;
  computed_logo_url: string;
  computed_banner_url: string;
  computed_font_family: string;
  computed_button_border_radius: string;
  created_at: string;
  updated_at: string;
};

export type UpdateReviewEmailTemplate = Partial<
  Pick<
    ReviewEmailTemplate,
    | "email_title"
    | "email_subject"
    | "greeting_text"
    | "product_mention_text"
    | "message_body_text"
    | "support_note_text"
    | "section_header_text"
    | "submit_button_text"
    | "footer_trouble_text"
    | "footer_link_text"
    | "brand_color"
    | "background_color"
    | "logo_url"
    | "banner_url"
    | "font_family"
    | "button_border_radius"
  >
>;

export const BRAND_OPTIONS = [
  { value: "japanhaul", label: "JapanHaul" },
  { value: "sakuraco", label: "Sakuraco" },
  { value: "tokyotreat", label: "TokyoTreat" },
  { value: "ichigo", label: "Ichigo App" },
];

export const BRAND_COLORS: Record<string, string> = {
  japanhaul: "blue",
  sakuraco: "grape",
  tokyotreat: "teal",
  ichigo: "orange",
};

export const BRAND_LABELS: Record<string, string> = {
  japanhaul: "JapanHaul",
  sakuraco: "Sakuraco",
  tokyotreat: "TokyoTreat",
  ichigo: "Ichigo App",
};

export const EMAIL_TYPE_OPTIONS = [
  { value: "request_review", label: "Review Request" },
  { value: "review_reminder", label: "Review Reminder" },
  { value: "review_second_reminder", label: "Review Second Reminder" },
];

export const EMAIL_TYPE_LABELS: Record<string, string> = {
  request_review: "Review Request",
  review_reminder: "Review Reminder",
  review_second_reminder: "Review Second Reminder",
};

export const EMAIL_TYPE_COLORS: Record<string, string> = {
  request_review: "blue",
  review_reminder: "yellow",
  review_second_reminder: "orange",
};

export const FIELD_LABELS: Record<string, string> = {
  email_title: "Email Title",
  email_subject: "Email Subject",
  greeting_text: "Greeting Text",
  product_mention_text: "Product Mention Text",
  message_body_text: "Message Body Text",
  support_note_text: "Support Note Text",
  section_header_text: "Section Header Text",
  submit_button_text: "Button Text",
  footer_trouble_text: "Footer Trouble Text",
  footer_link_text: "Footer Link Text",
  brand_color: "Brand Color",
  background_color: "Background Color",
  logo_url: "Logo URL",
  banner_url: "Banner URL",
  font_family: "Font Family",
  button_border_radius: "Button Border Radius",
};

export const PLACEHOLDER_FIELDS = new Set([
  "email_title",
  "email_subject",
  "greeting_text",
  "product_mention_text",
  "message_body_text",
  "support_note_text",
  "section_header_text",
  "footer_trouble_text",
  "footer_link_text",
]);

export const PLACEHOLDERS = [
  "{customer_name}",
  "{customer_first_name}",
  "{product_names}",
  "{brand_name}",
  "{brand_color}",
  "{support_email}",
  "{support_link}",
];

export const FIELD_GROUPS: Record<string, string[]> = {
  "Email Meta": ["email_title", "email_subject"],
  Content: [
    "greeting_text",
    "product_mention_text",
    "message_body_text",
    "support_note_text",
    "section_header_text",
  ],
  Button: ["submit_button_text"],
  Footer: ["footer_trouble_text", "footer_link_text"],
  Styling: [
    "brand_color",
    "background_color",
    "logo_url",
    "banner_url",
    "font_family",
    "button_border_radius",
  ],
};

export const FONT_OPTIONS = [
  { value: "Arial, sans-serif", label: "Arial" },
  { value: "Helvetica, sans-serif", label: "Helvetica" },
  { value: "Georgia, serif", label: "Georgia" },
  { value: "Times New Roman, serif", label: "Times New Roman" },
  { value: "Verdana, sans-serif", label: "Verdana" },
  { value: "Trebuchet MS, sans-serif", label: "Trebuchet MS" },
  { value: "Tahoma, sans-serif", label: "Tahoma" },
];
